export default __webpack_public_path__ + "static/digipay-team-rahul-373197c286c249eb4a6103c7a26cea8a.png";